import React from 'react';
import { Button } from '@material-ui/core';
import { STATUS } from '../../utils/const';

import useStatusStyles from '../../hooks/objective/status/useStyle';

const StatusButton = ({ status, label, handleOnClick, disabled = false }) => {
  const classes = useStatusStyles();
  const setStatusOrOpenModelValue =
    status === STATUS.COMPLETED || status === STATUS.FAILED ? !!status : status;

  return (
    <Button
      variant='contained'
      key={ status }
      className={ `${classes[status]} ${classes.button}` }
      name={ status }
      onClick={ () => handleOnClick(setStatusOrOpenModelValue) }
      disabled={ disabled }
    >
      { label }
    </Button>
  );
};

export default StatusButton;
